/* eslint-disable @typescript-eslint/camelcase */

// https://console.cloud.google.com/apis/credentials?project=kaleasy-1534792437592

// Documentation: https://github.com/google/google-api-javascript-client
// This interfaces with the gapi loaded remotely in public/index.html of the web apps.
// types are supplied via npm @types/gapi
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/gapi/index.d.ts

export interface GoogleAuthConfiguration {
  clientId: string;
  apiKey: string;
}

let CLIENT_ID: string;
let API_KEY: string;
let GoogleAuth: gapi.auth2.GoogleAuth;

export function configureGoogleAuth({ clientId, apiKey }: GoogleAuthConfiguration) {
  CLIENT_ID = clientId;
  API_KEY = apiKey;
}

export default function loadGoogleAPI(signInStatusUpdate: (signedIn: boolean) => any): void {
  const { gapi } = window;
  if (!gapi || !CLIENT_ID || !API_KEY) {
    /**
     * The gapi is loaded (as recommended by Google) via a <script> tag in the public/index.html of the web apps.
     * Since it's loaded remotely we need to make sure it exists on the window before we call it.
     * Use a setTimeout with a short interval to re-call this function
     */
    setTimeout(() => loadGoogleAPI(signInStatusUpdate), 200);
    return;
  }

  gapi.load('client:auth2', () => {
    const googleConfig = {
      apiKey: API_KEY,
      clientId: CLIENT_ID,
      fetch_basic_profile: true,
      scope: 'profile email'
    };

    gapi.client.init(googleConfig).then(() => {
      GoogleAuth = gapi.auth2.getAuthInstance();
      // Listen for changes in the sign in status for Google. When it changes, call the signInStatusUpdate callback
      GoogleAuth.isSignedIn.listen(signInStatusUpdate);
      // Initial call to update signInStatusUpdate
      signInStatusUpdate(GoogleAuth.isSignedIn.get());
    });
  });
}

export function signGoogleUserIn() {
  const options = {
    scope: 'profile email',
    prompt: 'select_account'
  };
  GoogleAuth.signIn(options);
}

export function signGoogleUserOut() {
  if (!window.google) {
    setTimeout(signGoogleUserOut, 200);
    return;
  }

  return window.google.accounts.id.disableAutoSelect();
}
